// extracted by mini-css-extract-plugin
export var messageSideLeft = "_o0-1";
export var stateContainer = "_o0-0";